import * as Constants from './constants';

export const getEventType = event => {
    switch (event.originator.type) {
        case Constants.ORIGINATOR_TYPES.ACTION:
            return event.embed.actionType;
        case Constants.ORIGINATOR_TYPES.LEAVE:
            return event.embed.leaveType;
        default:
            return event.originator.type;
    }
};
